import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import { createUserManager, loadConfig } from './auth.ts';
import './styles.css';

async function start() {
  const root = createRoot(document.getElementById('root')!);
  try {
    const config = await loadConfig();
    const users = createUserManager(config);
    if (location.pathname === '/auth/callback') {
      try {
        await users.signinRedirectCallback();
      } finally {
        history.replaceState(null, '', '/');
      }
    }
    root.render(
      <StrictMode>
        <App config={config} users={users} />
      </StrictMode>,
    );
  } catch (e) {
    root.render(<main className="login">Der Writer antwortet nicht: {e instanceof Error ? e.message : String(e)}</main>);
  }
}

void start();
